module.exports = __webpack_public_path__ + "static/media/7.3cbc0d03.jpg";